import { trackEvent } from '@/core/analytics'

const SCREEN = { screenName: 'discover', screenType: 'page' }

export function trackDiscoveryScreenView(
  sectionsCount: number,
  featuredCode?: string | null,
) {
  trackEvent('screenView', {
    ...SCREEN,
    sectionsCount,
    featuredCode,
  })
}

export function trackFeaturedCardClicked(
  code: string | null | undefined,
  url: string,
) {
  trackEvent('featuredCardClicked', {
    ...SCREEN,
    elementType: 'card',
    elementName: 'featuredCard',
    itemUrl: url,
    itemCode: code,
  })
  trackEvent('discoveryItemOpened', {
    ...SCREEN,
    itemUrl: url,
    itemSource: 'featured',
  })
}

export function trackGridCardClicked(
  code: string | null | undefined,
  url: string,
  position: number,
) {
  trackEvent('gridCardClicked', {
    ...SCREEN,
    elementType: 'card',
    elementName: 'gridCard',
    itemUrl: url,
    itemCode: code,
    position,
  })
  trackEvent('discoveryItemOpened', {
    ...SCREEN,
    itemUrl: url,
    itemSource: 'grid',
  })
}

export function trackBannerCardClicked(
  code: string | null | undefined,
  url: string,
) {
  trackEvent('bannerCardClicked', {
    ...SCREEN,
    elementType: 'card',
    elementName: 'bannerCard',
    itemUrl: url,
    itemCode: code,
  })
  trackEvent('discoveryItemOpened', {
    ...SCREEN,
    itemUrl: url,
    itemSource: 'banner',
  })
}
